function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_776_532)"
}, /*#__PURE__*/React.createElement("rect", {
  y: 0.396484,
  width: 32,
  height: 32,
  rx: 8,
  fill: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.73 13.2164C22.73 13.3564 22.73 13.4864 22.73 13.6364C22.7253 15.2666 22.2832 16.8656 21.45 18.2667C20.6168 19.6677 19.4228 20.8196 17.9928 21.602C16.5627 22.3845 14.9489 22.7689 13.3196 22.7151C11.6903 22.6614 10.1054 22.1714 8.72998 21.2964C8.98498 21.3329 9.24241 21.3496 9.49998 21.3464C10.9501 21.3569 12.3607 20.8738 13.5 19.9764C12.8301 19.9631 12.181 19.741 11.6433 19.3413C11.1055 18.9416 10.7059 18.3841 10.5 17.7464C10.6967 17.7916 10.8983 17.8117 11.1 17.8064C11.3839 17.812 11.6671 17.7749 11.94 17.6964C11.2165 17.5487 10.5664 17.1554 10.0998 16.5831C9.63322 16.0108 9.37891 15.2948 9.37998 14.5564C9.82283 14.7974 10.3161 14.9309 10.82 14.9464C10.3835 14.6532 10.0258 14.2573 9.77821 13.7935C9.53061 13.3297 9.40073 12.8122 9.39998 12.2864C9.40455 11.7175 9.55612 11.1595 9.83998 10.6664C10.6397 11.6608 11.6418 12.4737 12.7797 13.0513C13.9176 13.6289 15.1653 13.9578 16.44 14.0164C16.3827 13.7774 16.3558 13.5322 16.36 13.2864C16.36 12.4377 16.6971 11.6238 17.2972 11.0237C17.8974 10.4236 18.7113 10.0864 19.56 10.0864C19.9973 10.0866 20.4301 10.1752 20.8323 10.3471C21.2344 10.5189 21.5976 10.7704 21.9 11.0864C22.6056 10.9455 23.282 10.6851 23.9 10.3164C23.6588 11.0572 23.158 11.6858 22.49 12.0864C23.1243 12.0039 23.7437 11.8322 24.33 11.5764C23.901 12.216 23.3588 12.7718 22.73 13.2164Z",
  fill: "#d4c3da"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_776_532"
}, /*#__PURE__*/React.createElement("rect", {
  y: 0.396484,
  width: 32,
  height: 32,
  rx: 8,
  fill: "white"
})));

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.6625ad1d.svg";
export { ForwardRef as ReactComponent };